import { useCallback, useEffect, useRef, useState } from 'react';

interface HoverPopoverState {
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  handleOpenChange: (nextOpen: boolean) => void;
}

export const useHoverPopover = (): HoverPopoverState => {
  const [isOpen, setIsOpen] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  useEffect(() => () => clearTimeout(timer.current), []);
  const handleClose = useCallback(() => {
    clearTimeout(timer.current);
    setIsOpen(false);
  }, []);
  const handleOpen = useCallback(() => {
    clearTimeout(timer.current);
    setIsOpen(true);
  }, []);
  const handleOpenChange = useCallback((nextOpen: boolean) => {
    clearTimeout(timer.current);
    if (nextOpen) setIsOpen(true);
    else timer.current = setTimeout(() => setIsOpen(false), 150);
  }, []);
  return { isOpen, handleOpen, handleClose, handleOpenChange };
};
